import { Injectable } from '@angular/core';
import { CanActivate, CanLoad, Router } from '@angular/router';

import { CapabilitiesService } from '../shared/shared-context/capabilities.service';
import { BaseRouteGuard } from './base.route-guard';

@Injectable({
    providedIn: 'root'
})
export class FeedRouteGuard extends BaseRouteGuard implements CanActivate, CanLoad {

    private readonly feedEnabled: boolean;
    constructor(
        capabilitiesService: CapabilitiesService,
        router: Router
    ) {
        super(router, capabilitiesService);
        this.feedEnabled = this.capabilitiesService.capabilities.feedEnabled;
    }

    public canActivate() {
        return this.checkEnabledAndRedirect(this.feedEnabled);
    }

    public canLoad() {
        return this.checkEnabledAndRedirect(this.feedEnabled);
    }
}
